import ProgressRing from 'components/ProgressRing';
import React from 'react';
import './Modules.scss';

const Progress = ({ sentiment, conversation, colour }) => {
  const sentimentScore = conversation.sentiment?.[sentiment];
  const isSentimentScoreANumber = !isNaN(parseInt(sentimentScore));
  if (!isSentimentScoreANumber) {
    return null;
  }
  return (
    <div className="ConversationAnalysis-sentiment-progress">
      <ProgressRing
        radius="45"
        stroke="8"
        progress={Math.round(conversation.sentiment[sentiment])}
        backgroundRingColor="#E2E8F0"
        highBreakpoint={0}
        textColor="#172554"
        highRingColor={colour}
        textWidth={'0.5px'}
      />
      <p>{sentiment}</p>
    </div>
  );
};

const ConversationAnalysis = (props) => {
  const { summary, sentiment } = props.conversation;
  return (
    <div className="ConversationAnalysis">
      {sentiment && (
        <div>
          <h5 className="ConversationAnalysis-header">Sentiment score</h5>
          <div className="ConversationAnalysis-sentiment">
            <Progress sentiment={'Positive'} colour={'#22C55E'} {...props} />
            <Progress sentiment={'Neutral'} colour={'#64748B'} {...props} />
            <Progress sentiment={'Negative'} colour={'#E2224C'} {...props} />
          </div>
        </div>
      )}
      {summary && (
        <div>
          <h5 className="ConversationAnalysis-header">Conversation summary</h5>
          <p className="ConversationAnalysis-summary">{summary}</p>
        </div>
      )}
    </div>
  );
};

export default ConversationAnalysis;
